import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetUtilServiceModel } from "@factory/model/query-model-util-service";
import { utilServiceFormDefault } from "./form.default";
import { UtilServiceFormSchema } from "./form.rule";

export const useFormDefaultUtilService = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetUtilServiceModel | undefined) => {
    return !cachedValue
      ? utilServiceFormDefault
     : ({
        tenant: cachedValue.tenant,
        name: cachedValue.name,
        description: cachedValue.description,
      } as UtilServiceFormSchema);
  };

  return {
    getDefault,
  };
};
